/* Keep the category tree compact on mobile; preserve native <details> without JS. */
if (!customElements.get('custom-category-navigation')) {
  customElements.define('custom-category-navigation', class extends HTMLElement {
    connectedCallback() {
      this.drawer = this.querySelector('[data-category-drawer]');
      if (!this.drawer) return;
      this.media = window.matchMedia('(min-width: 750px)');
      this.setViewportState = () => { this.drawer.open = this.media.matches; };
      this.setViewportState();
      this.media.addEventListener('change', this.setViewportState);
    }
    disconnectedCallback() {
      this.media?.removeEventListener('change', this.setViewportState);
    }
  });
}
/* Trade handles search suggestions. Add Escape dismissal for the persistent field. */
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const search = event.target.closest?.('predictive-search.custom-dealer-search');
  if (search && typeof search.close === 'function') search.close();
});
